export const CLASS_NAMES = {
  row: "flex flex-row gap-x-2",
  firstRow: "flex flex-row gap-x-2 mb-2",
};
